import { createMap, forMember, mapFrom, constructUsing } from "@automapper/core";
const boUserGroupMappingKeys = {
  model: "BoUserGroup.Model",
  viewModel: "BoUserGroup.ViewModel",
  queryFields: "BoUserGroup.QueryFields",
  viewModelKeys: "BoUserGroup.ViewModelKeys"
};
class BoUserGroupMapping {
  createMapping(mapper) {
    createMap(
      mapper,
      boUserGroupMappingKeys.model,
      boUserGroupMappingKeys.viewModel,
      forMember(
        (vm) => vm.id,
        mapFrom((m) => m.id)
      ),
      forMember(
        (vm) => vm.name,
        mapFrom((m) => m.name)
      )
    );
    createMap(
      mapper,
      boUserGroupMappingKeys.viewModelKeys,
      boUserGroupMappingKeys.queryFields,
      constructUsing((m) => {
        const mapper2 = {
          id: "id",
          name: "name"
        };
        return mapper2[m];
      })
    );
  }
}
export {
  BoUserGroupMapping,
  boUserGroupMappingKeys
};
//# sourceMappingURL=mapper.js.map
